import { render, staticRenderFns } from "./CompanyMembers.vue?vue&type=template&id=47d52d5c&scoped=true&"
import script from "./CompanyMembers.vue?vue&type=script&lang=js&"
export * from "./CompanyMembers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d52d5c",
  null
  
)

export default component.exports